// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';

import { initializeScrollBehavior } from './modules/verfolger-nav.js';

document.addEventListener('DOMContentLoaded', () => {
  initializeScrollBehavior();
});
